// components/StockVisualizationCharts.js
import React from "react";
import { CandleStick, VWAPLineChart, VolumeBarChart, ChangePercLine } from "./charts";
import { PERIOD_CONFIG } from "./DateFilterButtons";

const StockVisualizationCharts = ({ chartData, selectedPeriod, stockInfo }) => {
  const filterDataByPeriod = (data, period) => {
    if (!data || !data.length) return data;

    const daysToShow = PERIOD_CONFIG[period]?.days;
    if (!daysToShow) return data;

    const sortedData = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));
    const sliced = sortedData.slice(0, daysToShow).reverse();

    return sliced;
  };

  const downsampleForNonCandles = (data, period) => {
    if (!data || !data.length) return data;
    if (PERIOD_CONFIG[period]?.downsampleForNonCandles) {
      return data.filter((_, i) => i % 30 === 0);
    }
    return data;
  };

  const filtered = filterDataByPeriod(chartData, selectedPeriod);
  const filteredForCandleStick = filtered;
  const filteredForOtherCharts = downsampleForNonCandles(filtered, selectedPeriod);
  const filteredForVwapChart = filtered;
  const filteredForVolumeChart = filtered;
  const filteredForChangePercChart = filtered;

  return (
    <>
      <div className="chart-wrapper">
        <CandleStick
          chartData={filteredForCandleStick}
          stockInfo={stockInfo}
          selectedPeriod={selectedPeriod}
        />
      </div>

      <div className="chart-wrapper">
        <VWAPLineChart
          chartData={filteredForVwapChart}
          stockInfo={stockInfo}
          selectedPeriod={selectedPeriod}
        />
      </div>
      <div className="chart-wrapper">
        <VolumeBarChart
          chartData={filteredForVolumeChart}
          stockInfo={stockInfo}
          selectedPeriod={selectedPeriod}
        />
      </div>
      <div className="chart-wrapper">
        {/* <ChangePercLine chartData={filtered} stockInfo={stockInfo} /> */}

        <ChangePercLine
          chartData={filteredForChangePercChart}
          stockInfo={stockInfo}
          selectedPeriod={selectedPeriod}
        />
      </div>
    </>
  );
};

export default StockVisualizationCharts;
